const KNOCK_ABORT_MESSAGE_PATTERNS = [
  "request aborted",
  "request cancelled",
  "request canceled",
  "network error",
];

/**
 * Stack-trace patterns that identify Knock SDK call-sites.  In development
 * the full module path survives (`@knocklabs/client`); in production builds
 * the code is bundled into numbered webpack chunks but internal function
 * names like `batchUpdateStatuses` and `handleResponse` survive
 * minification.
 */
const KNOCK_STACK_PATTERNS = [
  /@knocklabs\/client/,
  /batchUpdateStatuses/,
  /handleResponse/,
];

/**
 * Detects Knock SDK abort/network errors that occur when the user navigates
 * away while the Knock `NotificationFeed` component has in-flight
 * `batchUpdateStatuses` API requests.  These are benign — the request was
 * simply cancelled because the page is no longer visible — and should not
 * surface as errors in Datadog.
 *
 * This filter is used in Datadog's `beforeSend` callback so it operates on
 * the raw `{message, stack}` shape that the RUM/Logs SDKs provide, rather
 * than on Error instances.
 */
export function isKnockAbortError(error: {
  message?: string;
  stack?: string;
}): boolean {
  const message = error.message?.toLowerCase() ?? "";

  const isAbortMessage = KNOCK_ABORT_MESSAGE_PATTERNS.some((pattern) =>
    message.includes(pattern),
  );

  if (!isAbortMessage) {
    return false;
  }

  const stack = error.stack ?? "";
  return KNOCK_STACK_PATTERNS.some((pattern) => pattern.test(stack));
}
